import React from 'react'
import { Field } from '@chakra-ui/react'

export default (props) => {
  return (
    <Field.Root>
      <Field.Label required={props.required || props.isRequired} fontWeight='semibold'>{props.label}</Field.Label>
      {props.children}
      <Field.HelperText>{props.helperText}</Field.HelperText>
      <Field.ErrorText>{props.errorText}</Field.ErrorText>
    </Field.Root>
  )
}
